/**
 * Colours that tell entities apart (routes on a map, series in a chart). Assigned in this order and
 * never cycled: a ninth entity gets no colour of its own — leave it out, group it, or split the view.
 *
 * Validated as a set (lightness band, chroma, colour-blind and normal-vision separation of neighbours)
 * against light surfaces, the app's and HERE's map. Several slots sit under 3:1 contrast on those
 * surfaces, so a colour never identifies anything alone: pair it with a visible label.
 * Re-validate the whole list before changing any entry.
 */
export const CATEGORICAL_COLORS = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#6250d6', '#e34948'] as const;
